import { HeadingProps } from "../../Types/CommonElementType";

const H4:React.FC<HeadingProps> = (props) => {
  const { children = "" } = props;
  return (
    <h4 {...props} style={props.style}>
      {children}
    </h4>
  );
};

export default H4;
